export default {
  state: {
    goToPoint: "healthCareTwoAnimation",
    initialGoToPoint: "",
    dx: 0,
    dy: 0,
    scale: 1,
    maxScale: 2.15,
    minScale: 1,
    specificScale: 0,
    isZoomed: true,
    isNotZoomedHighlight: false,
    removeTransitionDuration: false
  },
  mutations: {
    updateGoToPoint(state, payload) {
      state.goToPoint = payload;
    },
    updateInitialGoToPoint(state, payload) {
      state.initialGoToPoint = payload;
    },
    updateDxDy(state, payload) {
      state.dx = payload.dx;
      state.dy = payload.dy;
    },
    updateScale(state, payload) {
      state.scale = state[payload];
    },
    updateIsZoomed(state, payload) {
      state.isZoomed = payload;
    },
    updateIsNotZoomedHighlight(state, payload) {
      state.isNotZoomedHighlight = payload;
    },
    updateRemoveTransitionDuration(state, payload) {
      state.removeTransitionDuration = payload;
    },
    updateSpecificScale(state, payload) {
      state.specificScale = payload;
      state.scale = payload;
    },
    updateMaxScale(state, payload) {
      state.maxScale = payload;
    }
  }
};
